@switch (state()) {
  @case (states.Show) {
    <nav class="breadcrumbs" [attr.aria-label]="'SHARED.BREADCRUMBS.NAV_ARIA' | translate">
      <ol class="breadcrumb-list" role="list">
        <li
          *ngFor="let item of items(); let last = last; let i = index"
          class="breadcrumb-item"
          [attr.aria-current]="last ? 'page' : null">

          <a
            *ngIf="item.route && !last; else textNode"
            class="breadcrumb-link"
            [routerLink]="item.route"
            [queryParams]="item.queryParams"
            [attr.aria-label]="('SHARED.BREADCRUMBS.NAVIGATE_TO' | translate) + ' ' + (item.label | translate)">
            {{ item.label | translate }}
          </a>

          <ng-template #textNode>
        <span class="breadcrumb-current">
          {{ item.label | translate }}
        </span>
          </ng-template>

          <span
            *ngIf="!last"
            class="breadcrumb-separator"
            aria-hidden="true">
        //
      </span>
        </li>
      </ol>
    </nav>
  }
  @case (states.Loading) {
    <div class="breadcrumbs">
      <under-ui-skeleton width="50%"></under-ui-skeleton>
    </div>
  }
  @default {
    <!--EMPTY-->
  }
}
